import { render, staticRenderFns } from "./reply-comment.vue?vue&type=template&id=cf24f9e6&scoped=true"
import script from "./reply-comment.vue?vue&type=script&lang=js"
export * from "./reply-comment.vue?vue&type=script&lang=js"
import style0 from "./reply-comment.vue?vue&type=style&index=0&id=cf24f9e6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf24f9e6",
  null
  
)

export default component.exports